import React from 'react';
import clsx from 'clsx';
import * as styles from './Link.module.scss';
export function useLinkStyles(props) {
    const className = clsx(styles.link, props.inheritStyling && styles.inheritStyling, props.className);
    return className;
}
const Name = 'Link';
function getChild(children) {
    // Ensure text isn't passed standalone to the <Link />
    if (typeof children === 'string') {
        return null;
    }
    // Validate there is a single child
    return React.Children.only(children);
}
export const Link = props => {
    const { children, ...linkProps } = props;
    const className = useLinkStyles(linkProps);
    const element = getChild(children);
    if (!element) {
        return null;
    }
    return React.cloneElement(element, {
        'data-component': Name,
        className,
    });
};
